import { ReactElement } from 'react';
import { Header, Text } from '@mantine/core';
import styles from './TopBanner.module.scss';
import { Trans, useTranslation } from 'react-i18next';
import ClickableRegion from '../ClickableRegion';
import { TextComponent } from '@manifest-cyber/design-system/lib/components/TextComponent';

interface TopBannerProps {
  height?: number;
  children?: ReactElement;
  className?: string;
}

export const TopBanner = ({ height = 43, className, children }: TopBannerProps) => {
  return (
    <Header fixed height={height} className={className ?? styles.topBanner}>
      {children}
    </Header>
  );
};

export function TopAibomBanner() {
  const { t } = useTranslation();
  const learnMoreLink = 'https://docs.manifestcyber.com';
  return (
    <TopBanner height={36} className={styles.topAibomBanner}>
      <>

        <TextComponent color="white" variant="bodySmall" className={styles.uppercase}>
          {t('ai-banner.ai-only-access')}
        </TextComponent>
        <ClickableRegion href={learnMoreLink}>
          <TextComponent color="white" variant="bodySmall">{t('ai-banner.learn-more')}</TextComponent>
        </ClickableRegion>
      </>
    </TopBanner>
  );
}

export function TopLMCOBanner() {
  return (
    <TopBanner height={43}>
      <Text color="white" weight={500}>
        <Text className={styles.orgNotes}>
          <Trans
            i18nKey="page.agreement.LCMOFooter"
            components={{
              lmpi: <span style={{ color: 'white', fontWeight: 700 }} />,
              tppi: <span style={{ color: 'white', fontWeight: 700 }} />,
              cui: <span style={{ color: 'white', fontWeight: 700 }} />,
            }}
          />
        </Text>
      </Text>
    </TopBanner>
  );
}
